var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('page-not-found')))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('this-page-could-not-be-found'))+" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('go-back'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }